import { create } from "zustand";

const useLocationStore = create((set) => {
    const savedLocation = localStorage.getItem("selectedLocation");

    return {
        selectedLocation: savedLocation ? JSON.parse(savedLocation) : null,
        setSelectedLocation: (location) => {
            localStorage.setItem("selectedLocation", JSON.stringify(location));
            set({ selectedLocation: location });
        },
        clearLocation: () => {
            localStorage.removeItem("selectedLocation");
            set({ selectedLocation: null });
        },
    };
});

export default useLocationStore;
